import * as React from 'react';

import type { IconProps } from '../../types';

/**
 * Dollar icon
 *
 * @category Business
 */
const Dollar = React.forwardRef<SVGSVGElement, IconProps>(
  ({ 'data-testid': testId, size = 20, className, ...props }, ref) => {
    return (
      <svg
        ref={ref}
        data-testid={testId}
        width={size}
        height={size}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        role="img"
        aria-hidden="true"
        {...props}
      >
        <path
          fill="currentColor"
          d="M15.993 2.979c9.71-.206 16.228 10.676 11.569 19.172-4.012 8.108-15.859 9.282-21.524 2.239-7.204-8.312-1.19-21.356 9.765-21.41v-.001zm10.395 7.136c-3.39-6.566-12.83-7.952-18.166-2.953l-.003.003c-8.18 7.08-3.38 20.46 7.348 20.696l.097.003v.01h.096c8.987.268 15.134-9.948 10.63-17.755zM15.68 7.947a.56.56 0 0 1 .683.051h.001c.18.146.227.377.262.559.019.097.034.182.06.257a.35.35 0 0 0 .091.15q.336.151.693.29c.241.098.487.197.724.308.47.22.916.494 1.242.906l.213.26c.211.274.407.593.54.928.176.447.246.933.082 1.383l-.003.008c-.163.353-.631.454-.91.176v-.001c-.162-.157-.236-.372-.288-.575-.056-.215-.088-.41-.163-.576l-.002-.004c-.216-.54-.662-.999-1.256-1.307h-.001q-.113-.047-.223-.097l-.22-.097c-.143-.06-.263-.1-.355-.107a.2.2 0 0 0-.099.01.1.1 0 0 0-.054.053c-.026.047-.044.13-.039.271l.014.16.001.006.018.52c.007.547-.013 1.17-.025 1.777-.015.79-.015 1.552.076 2.114l.019.008c2.073.317 3.327 1.759 3.557 3.313.23 1.56-.574 3.217-2.576 3.947h.001c-.147.06-.31.104-.454.146a2 2 0 0 0-.375.134l-.004.002a.4.4 0 0 0-.19.202c-.044.096-.069.21-.099.335-.055.233-.127.536-.437.635h-.001q-.308.091-.501-.038c-.125-.082-.198-.218-.25-.35-.05-.132-.087-.288-.124-.412a.9.9 0 0 0-.125-.28q-.331-.147-.685-.285a14 14 0 0 1-.723-.307c-.471-.221-.917-.495-1.243-.906l-.214-.26a4 4 0 0 1-.539-.929c-.176-.446-.246-.932-.082-1.383l.005-.013.01-.012q.228-.31.482-.33c.17-.01.313.082.423.204.216.239.357.646.394.946.118.446.457.875.884 1.203.424.325.922.54 1.348.576.033-.005.047-.014.053-.023.01-.012.021-.04.022-.1l-.007-1.018c0-.433.002-.936.004-1.429.002-.976.002-1.913-.02-2.227-.014-.036-.041-.067-.1-.097a1.5 1.5 0 0 0-.3-.098c-1.93-.39-3.067-1.781-3.261-3.271-.194-1.492.559-3.071 2.374-3.82a3.6 3.6 0 0 1 .562-.202c.19-.056.357-.105.483-.167a.46.46 0 0 0 .194-.196.7.7 0 0 0 .051-.136l.031-.17a.79.79 0 0 1 .35-.615m.993 13.55c1.394-.247 2.406-1.235 2.406-2.385s-1.012-2.138-2.406-2.384zM15.34 10.494c-1.384.247-2.406 1.236-2.406 2.385 0 1.15 1.012 2.138 2.406 2.385z"
        />
      </svg>
    );
  }
);

Dollar.displayName = 'Dollar';

export { Dollar };
